import { useSelector, useDispatch } from "react-redux";
import { toggleCapsulesPopup } from "../../store/slices/capsules-slice";

import CapsuleCardHorizontal from "~/components/CapsuleCardHorizontal/CapsuleCardHorizontal.jsx";
import PriceSummary from "~/components/PriceSummary/PriceSummary.jsx";
import PickYourCapsules from "~/assets/pick-your-capsules.png";
import "./CapsuleSelection.css";

const CapsuleSelection = ({ selectedCapsules, data, handleQuantityChange }) => {
  const hasConfirmedSelection = useSelector((state) => state.capsules.hasConfirmedSelection);

  const dispatch = useDispatch();

  return (
    <div className="section capsule-selection-top">
      <h2>3. Pick Your Capsules</h2>
      {hasConfirmedSelection && selectedCapsules.length > 0 && (
        <div className="selected-capsules">
          <div className="selected-capsules-list">
            {selectedCapsules.map((capsule) => {
              console.log("capsule", capsule);

              const product = data.DynamicBox.selectableProductVariants.find((prod) =>
                prod.productVariants.some((variant) => variant.platformId === capsule.platformId)
              );

              const variant = product?.productVariants.find(
                (variant) => variant.platformId === capsule.platformId
              );

              if (!product || !variant) {
                return null;
              }

              return (
                <CapsuleCardHorizontal
                  key={capsule.platformId}
                  data={data}
                  product={product}
                  variant={variant}
                  handleQuantityChange={handleQuantityChange}
                  quantity={capsule.quantity}
                  totalItems={selectedCapsules.length}
                />
              );
            })}
          </div>
        </div>
      )}

      <div className="capsule-selection-bottom">
        <button onClick={() => dispatch(toggleCapsulesPopup())} className="pick-your-capsules-btn">
          {
            hasConfirmedSelection && selectedCapsules.length > 0
              ? "Edit Selection"
              : "Choose capsules"
            // <>
            //   <picture>
            //     <source
            //       media="(max-width: 768px)"
            //       srcSet="https://cdn.shopify.com/s/files/1/0038/6049/6433/files/pick-your-capsules-mobile.png?v=1727990615"
            //     />
            //     <img
            //       className="pick-your-capsules-img"
            //       src="https://cdn.shopify.com/s/files/1/0038/6049/6433/files/pick-your-capsules.png?v=1727990615"
            //       alt="Pick your capsules"
            //       loading="lazy"
            //     />
            //   </picture>
            // </>
          }
        </button>

        {hasConfirmedSelection && selectedCapsules.length > 0 && (
          <PriceSummary data={data} selectedCapsules={selectedCapsules} />
        )}
      </div>
    </div>
  );
};

export default CapsuleSelection;
